<template>
  <div class="master-list">
    <!-- 卡片视图区域 -->
    <el-card>
      <!-- 搜索与添加区域 -->
      <el-row>
        <el-col :span='6' v-if="keys.includes('addr')||!keys.length">
          <span>地 区：</span>
          <el-input size="small" v-model="queryInfo.form.addr" clearable @clear="getMasterList">
          </el-input>
        </el-col>
        <el-col :span='6' v-if="keys.includes('domain')||!keys.length">
          <span>研究领域：</span>
          <el-input size="small" v-model="queryInfo.form.domain" clearable @clear="getMasterList"></el-input>

        </el-col>
        <el-col :span='6' v-if="keys.includes('subject')||!keys.length">
          <span>学 科：</span>
           <!-- <el-select v-model="queryInfo.form.subject" size="small" clearable @clear="getMasterList">
            <el-option v-for="(value,key) in subjectMap" :key="key" :label="value" :value="key">
            </el-option>
          </el-select>  -->
          <el-input size="small" v-model="queryInfo.form.subject" clearable @clear="getMasterList"></el-input>
        </el-col>
        <el-col :span='6' v-if="keys.includes('stage')||!keys.length">
          <span>学段：</span>
           <!-- <el-select v-model="queryInfo.form.stage" size="small" clearable @clear="getMasterList">
            <el-option v-for="(value,key) in stageMap" :key="key" :label="value" :value="key">
            </el-option>
          </el-select>   -->
          <el-input size="small" v-model="queryInfo.form.stage" clearable @clear="getMasterList">
          </el-input>
        </el-col>
        <el-col :span='6' v-if="keys.includes('company')||!keys.length">
          <span>单 位：</span>
          <el-input size="small" v-model="queryInfo.form.company" clearable @clear="getMasterList">
          </el-input>
        </el-col>
        <el-col :span='6' v-if="keys.includes('isRetire')||!keys.length">
          <span>是否退休：</span>
          <el-select v-model="queryInfo.form.isRetire" size="small" clearable @clear="getMasterList">
            <el-option label="1" value="是"></el-option>
            <el-option label="0" value="否"></el-option>

          </el-select>
        </el-col>
        <el-col :span='6' v-if="keys.includes('name')||!keys.length">
          <span>姓 名：</span>
          <el-input size="small" v-model="queryInfo.form.name" clearable @clear="getMasterList">
          </el-input>
        </el-col>

        <el-col :span='6' v-if="keys.includes('competent')||!keys.length">
          <span>职 称：</span>
          <el-input size="small" v-model="queryInfo.form.competent" clearable @clear="getMasterList">
          </el-input>
        </el-col>

        <el-col class="btns">
          <el-button icon="el-icon-document-add" size="small" class="new" @click="create" v-has="'btn_masterlist_create'">新建</el-button>
          <el-button icon="el-icon-upload2" size="small" class="import" @click="importMember" v-has="'btn_masterlist_import'">导入</el-button>
          <el-button size="small" class="reset" @click="reset">重置</el-button>
          <el-button v-on:click="getMasterList" size="small" class="query">查询</el-button>
        </el-col>
      </el-row>
      <!-- 项目列表区域 -->
      <el-table :data="masterlist" border stripe header-row-class-name="theader" height="500">
        <el-table-column label="序号" align='center' prop="id" type="index" :index="indexMethod"  width="50px" fixed></el-table-column>
        <el-table-column label="地区" align='center' fixed>
          <template slot-scope="scope">
            <span v-if="keys.includes('addr')||!keys.length||scope.row.createId==userInfo.id">{{scope.row.addr}}</span>
          </template>
        </el-table-column>
        <el-table-column label="姓名" align='center' fixed>
          <template slot-scope="scope">
            <span v-if="keys.includes('name')||!keys.length||scope.row.createId==userInfo.id">{{scope.row.name}}</span>
          </template>
        </el-table-column>
        <el-table-column label="性别" align='center' fixed>
          <template slot-scope="scope">
            <span v-if="keys.includes('sex')||!keys.length||scope.row.createId==userInfo.id">{{sexMap[scope.row.sex]}}</span>
          </template>
        </el-table-column>
        <el-table-column label="学科" align='center' :prop="'subject'">
          <template slot-scope="scope">
            <span v-if="keys.includes('subject')||!keys.length||scope.row.createId==userInfo.id">
              {{scope.row.subject}}
              </span>
          </template>
        </el-table-column>
        <el-table-column label="学段" align='center' prop="stage">
          <template slot-scope="scope">
            <span v-if="keys.includes('stage')||!keys.length||scope.row.createId==userInfo.id">
              {{scope.row.stage}}
              </span>
          </template>
        </el-table-column>
        <el-table-column label="单位" align='center' prop="company">
          <template slot-scope="scope">
            <span v-if="keys.includes('company')||!keys.length||scope.row.createId==userInfo.id">{{scope.row.company}}</span>
          </template>
        </el-table-column>
        <el-table-column label="职位" align='center' prop="job">
          <template slot-scope="scope">
            <span v-if="keys.includes('company')||!keys.job">{{scope.row.job}}</span>
          </template>
        </el-table-column>
        <el-table-column label="职称" align='center' prop="competent">
          <template slot-scope="scope">
            <span v-if="keys.includes('competent')||!keys.length||scope.row.createId==userInfo.id">{{scope.row.competent}}</span>
          </template>
        </el-table-column>
        <el-table-column label="是否退休" align='center'>
          <template slot-scope="scope">
            <span v-if="keys.includes('competent')||!keys.length||scope.row.createId==userInfo.id">
              {{scope.row.isRetire==1?'是':'否'}}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="研究领域" align='center'  prop="domain">
          <template slot-scope="scope">
            <span v-if="keys.includes('domain')||!keys.length||scope.row.createId==userInfo.id">
              {{scope.row.domain}}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="电话" align='center' prop="linkPhone">
          <template slot-scope="scope">
            <span v-if="keys.includes('linkPhone')||!keys.length||scope.row.createId==userInfo.id">
              {{scope.row.linkPhone}}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="开户行" align='center'>
          <template slot-scope="scope">
            <span v-if="keys.includes('bankName')||!keys.length||scope.row.createId==userInfo.id">
              {{scope.row.bankName}}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="银行账号" align='center'>
          <template slot-scope="scope">
            <span v-if="keys.includes('bankCart')||!keys.length||scope.row.createId==userInfo.id">
              {{scope.row.bankCart}}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="身份证" align='center'>
          <template slot-scope="scope">
            <span v-if="keys.includes('cartNo')||!keys.length||scope.row.createId==userInfo.id">
              {{scope.row.cartNo}}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="生日" align='center'>
          <template slot-scope="scope">
            <span v-if="keys.includes('birthday')||!keys.length||scope.row.createId==userInfo.id">
              {{scope.row.birthday|dateFormat('YYYY-MM-DD')}}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="建立时间" align='center'>
          <template slot-scope="scope">
            <span v-if="keys.includes('createTime')||!keys.length||scope.row.createId==userInfo.id">
              {{scope.row.createTime|dateFormat}}
            </span>
          </template>
        </el-table-column>

        <el-table-column label="操作" class-name='opt-box' width="270px"  fixed="right">
          <template slot-scope="scope">
            <!-- 修改按钮 -->
            <el-button size="mini" type="primary" icon="el-icon-edit" @click="editMaster(scope.row.id)" v-if="permissionList.includes('btn_masterlist_edit')||scope.row.createId==userInfo.id">编辑</el-button>
            <el-button size="mini" type="warning" icon="el-icon-setting" @click="masterDetial(scope.row.id)" v-if="permissionList.includes('btn_masterlist_detail')||scope.row.createId==userInfo.id">详情</el-button>
            <el-button type="danger" icon="el-icon-delete" size="mini" @click="removeById(scope.row.id)" v-if="permissionList.includes('btn_masterlist_del')">删除</el-button>

          </template>
        </el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.page" :page-sizes="[20, 50,100,200]" :page-size="queryInfo.size" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </el-card>

    <member-import ref="memberImport" @close='importShow = false;getMasterList()' :title="'专家信息导入'" :show='importShow'></member-import>

  </div>
</template>

<script>
import commonData from '../../common/commonData'
import * as resourceApi from '../../api/resourceAPI'
import * as permissionApi from '../../api/permissionAPI'
import utils from '../../common/utils'
import memberImport from '../subcomponents/member_import.vue'


import moment from 'moment'
export default {
  data() {
    return {
      // 获取用户列表的参数对象
      queryInfo: {
        form: {
          query: '',
          // queryDate: [],
          name: "",
        },
        // 当前的页数
        page: 1,
        // 当前每页显示多少条数据
        size: 20,

      },
      masterlist: [],
      total: 0,
      userInfo: {},
      pickerOptions: {},
      statusMap: {},
      stageMap: {},
      subjectMap: {},
      importShow: false,
      cols: '*',
      keys: [],
      sexMap: { 1: '男', 0: '女' }
    }
  },
  async created() {
    this.permissionList = await this.$store.getters.getPermissionList

    this.queryInfo.page = Number.parseInt(this.$route.query.page || 1);
    this.queryInfo.size = Number.parseInt(this.$route.query.size || 20);
    this.queryInfo.form.query = this.$route.query.query || '';

    this.pickerOptions = commonData.pickerOptions;
    this.stageMap = commonData.stage;
    this.subjectMap = commonData.subject
    this.userInfo = await this.$store.getters.getUserInfo
    await this.getFieldList()
    await this.getMasterList()
  },
  methods: {
    async getFieldList() {
      let param = { name: '专家初级字段权限' }
      let res = await permissionApi.getPermissionList(param)
      if (res.flag) {
        if (res.data.length) {
          this.cols = res.data[0].value
          this.keys = res.data[0].value.split(',')
        }
      }
    },
    async getMasterList() {
      let param = { ...this.queryInfo }
      let likeName = ['name', 'company', 'job', 'linkPhone', 'addr','subject','stage','domain']
      param.where = []
      // param.cols = this.cols
      param.orderBy = 'create_time desc'
      for (const key in param.form) {
        const val = param.form[key];
        if (val) {
          let type = likeName.includes(key) ? 'like' : 'eq'
          if (key == 'birthday' && val && val.length == 2) {
            param.where.push({ filed: key, type: 'gt', value: val[0] })
            param.where.push({ filed: key, type: 'lt', value: val[1] })
          } else {
            param.where.push({ filed: key, type, value: val })
          }
        }
      }

      param.name = 'tb_master'
      let res = await resourceApi.list(param)
      if (res.flag) {
        this.masterlist = res.data.list
        // let set = new Set([...this.keys, ...res.data.list.map(item => Object.keys(item)).flat()])

        // this.keys = [...set]
        this.total = res.data.total
      }
    },


    // 监听 size 改变的事件
    handleSizeChange(newSize) {
      // console.log(newSize)
      this.queryInfo.size = newSize
      this.getMasterList()
    },
    // 监听 页码值 改变的事件
    handleCurrentChange(newPage) {
      console.log(newPage)
      this.queryInfo.page = newPage
      this.getMasterList()
    },



    getTagType(status) {
      var json = { 0: 'info', 1: "info", 2: '', 3: 'success', 4: 'info', 5: '', 6: 'danger' }
      return json[status];
    },
    getStatus(row) {
      let status = this.statusMap[row.state]
      if (row.is_plan == 1) {
        status = this.statusMap1[row.state]
      }
      return status
    },
    reset() {
      this.queryInfo.form = {}
    },
    create() {
      this.$router.push("/addmaster");
    },
    editMaster(id) {
      this.$router.push("/editmaster/" + id);
    },
    masterDetial(id) {
      this.$router.push("/masterdetail/" + id);
    },
    importMember() {
      this.importShow = true
    },
    async removeById(id) {
      // 弹框询问项目是否删除数据
      const confirmResult = await this.$confirm('此操作将永久删除该专家, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch((err) => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('已取消删除')
      }
      let param = {}
      param.where = [{ filed: 'id', type: 'eq', value: id }]
      param.name = 'tb_master'
      let res = await resourceApi.del(param)
      if (res.flag) {
        this.getMasterList()
        this.$message.success('删除成功')
      }

    },
    indexMethod(index){
      return (this.queryInfo.page-1)*this.queryInfo.size+index+1
    }

  },
  components: {
    memberImport
  },
  computed: {
    /*  cols(){
       let col = "id,name,stage,sex,company,job,is_retire"
       if(['root','admin'].includes(this.userInfo.code)){
         col = '*'
       }
       return col
     } */
  }
}
</script>

<style lang="less" >
.master-list {
  .el-row {
    display: flex;
    flex-wrap: wrap;
    .el-col {
      display: flex;
      font-size: 14px;
      color: #3c4353;
      margin-bottom: 20px;
      align-items: center;
      > span {
        white-space: nowrap;
        min-width: 100px;
        text-align: right;
      }
      .el-select,
      .el-date-editor {
        width: 100%;
      }
    }
    .btns {
      justify-content: flex-end;
      margin-bottom: 0;
      .new {
        background: #dde5ff;
        border: none;
        color: #5373f5;
        width: 80px;
      }
      .query {
        border: none;
        background: #5373f5;
        color: #fff;
        width: 80px;
      }
      .reset {
        border: none;
        background: #e6e9ef;
        color: #666666;
        width: 80px;
      }
      .import {
        border: none;
        background: #fff2d1;
        color: #f1b535;
        width: 80px;
      }
    }
  }

  .opt-box {
    .cell {
      padding-left: 10px;
      padding-right: 0;
      .detail {
        background: #5373f5;
        color: #fff;
        border: none;
      }
    }
  }
  .theader th {
    background: #e6e9ef !important;
    color: #3c4353;
    border-color: #e5e5e5;
  }
  .el-tooltip__popper.is-dark {
    white-space: nowrap;
  }
}
</style>
